module.exports = "/images/ready-to-go.svg?7a4be9be06924cb9b90acecc8229cade";